import React, { useEffect, useState } from "react"
import { NavDropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import Flag from "react-world-flags"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { RootState } from "../store"
import { logout, setSideBarState } from "../store/auth.store"
import { setWarehouse } from "../store/warehouse.store"

export const handleMenuButtonClick = () => {
    const menuBar = document.querySelector(".sidebar")
    menuBar?.classList.toggle("mobile")
}

const Nav = () => {
    const dispatch = useAppDispatch()
    const { userInfo, sideBarState } = useAppSelector((state: RootState) => state.auth)
    const [selectedWarehouse, setSelectedWarehouse] = useState(
        userInfo?.ParcelHubUserWarehouse?.find((uw: Record<string, any>) => uw?.is_default)?.warehouse_id
    )
    const location = useLocation()
    const { t } = useTranslation()
    const handleLogout = () => {
        dispatch(logout())
        window.location.href = "/login"
    }

    useEffect(() => {
        if (selectedWarehouse) {
            dispatch(setWarehouse(selectedWarehouse))
        }
    }, [selectedWarehouse, dispatch])

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.warehouse_id === selectedWarehouse
    )?.Warehouse

    return (
        <div
            className={`nav-bar dash_user p-x-30 py-3 d-flex justify-content-end align-items-center white-background ${
                location.pathname !== "/" ? "shadow-none" : "nav-bar-dashboard"
            }`}>
            <div className="d-flex d-sm-none justify-content-start tr-pointer">
                <i
                    onClick={() => {
                        dispatch(setSideBarState(!sideBarState))
                        handleMenuButtonClick()
                    }}
                    className="bx bx-menu pr-4 "
                    id="menuBtn"></i>
            </div>

            <div className="d-flex justify-content-end align-items-center white-background username-color px-2">
                <NavDropdown
                    title={userInfo?.full_name || t("Parcel Hub admin")}
                    id="basic-nav-dropdown"
                    className="username-color">
                    <NavDropdown.Item className="overflow-hidden" onClick={() => handleLogout()}>
                        {t("Logout")}
                    </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown
                    title={
                        <>
                            <Flag className="d-inline flag mx-2" code={defaultWarehouse?.country} />
                            {defaultWarehouse?.name || t("")}
                        </>
                    }
                    id="basic-nav-dropdown"
                    className="username-color"
                    disabled={userInfo?.ParcelHubUserWarehouse?.length === 1}>
                    {userInfo?.ParcelHubUserWarehouse?.filter(
                        (uw: Record<string, any>) => uw.warehouse_id !== selectedWarehouse
                    )?.map((uw: Record<string, any>) => (
                        <NavDropdown.Item
                            key={`${uw?.Warehouse?.name}-${uw?.warehouse_id}`}
                            onClick={async () => {
                                setSelectedWarehouse(uw?.warehouse_id)
                                localStorage.setItem("warhouse", uw.warehouse_id)
                            }}>
                            {uw?.Warehouse?.name}
                        </NavDropdown.Item>
                    ))}
                </NavDropdown>
            </div>
        </div>
    )
}

export default Nav
